export enum NavItemsActionType {

  // Load Permitted Navigation Items
  LoadNavItems            = 'LOAD_NAV_ITEMS',
  LoadNavItemsCompleted   = 'LOAD_NAV_ITEMS_COMPLETED',
  LoadNavItemsFailed      = 'LOAD_NAV_ITEMS_FAILED',

  // Reset
  ResetNavItems           = 'RESET_NAV_ITEMS',

}
